import { useQuery } from 'react-query';
import { axios, axios2 } from '@/lib/axiosData';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { ApiResponse, Listing, PropertyforRent } from '@/types';

export const propertyForRent = (id: string): Promise<Listing[]> => {
  return axios2.get(`panel-api/rent-property-list?id=${id}`);
};

type QueryFnType = typeof propertyForRent;

type UseListingOptions = {
  config?: QueryConfig<QueryFnType>;
  id: string;
};

export const useLatestRentProperty = ({ config, id }: UseListingOptions = { id: '' }) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['property-for-rent'],
    queryFn: () => propertyForRent(id),
  });
};
